import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { IProductionPurposeMixPieChartData } from '../../../performance/services/performance-scorecard.service';

@Component({
    selector: 'scorecards-product-purpose-mix-card',
    templateUrl: './scorecards-product-purpose-mix-card.component.html',
    styleUrls: ['./scorecards-product-purpose-mix-card.component.scss'],
})
export class ScorecardsProductPurposeMixCardComponent implements OnInit, OnChanges {
    constructor() {}
    @Input() pieChartsData: IProductionPurposeMixPieChartData;
    @Input() pageId: string;

    hasData: boolean;
    isDataLoaded: boolean;
    noDataDonutChart;

    ngOnInit() {
        this.hasData = false;
        this.isDataLoaded = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['pieChartsData']) {
            let currentData: IProductionPurposeMixPieChartData =
                changes['pieChartsData'].currentValue;
            if (currentData.isLoadingProductMix && currentData.isLoadingPurposeMix) {
                this.isDataLoaded = false;
            } else {
                this.isDataLoaded = true;
            }

            if (this.isDataLoaded && currentData.productMixChartLeft) {
                let chartTopLeft = new Highcharts.Chart(
                    this.pageId + 'chart-top-left',
                    currentData.productMixChartLeft
                );
            }
            if (this.isDataLoaded && currentData.productMixChartRight) {
                let chartTopRight = new Highcharts.Chart(
                    this.pageId + 'chart-top-right',
                    currentData.productMixChartRight
                );
            }
            if (this.isDataLoaded && currentData.purposeMixChartLeft) {
                let chartBotLeft = new Highcharts.Chart(
                    this.pageId + 'chart-bot-left',
                    currentData.purposeMixChartLeft
                );
            }
            if (this.isDataLoaded && currentData.purposeMixChartRight) {
                let chartBotRght = new Highcharts.Chart(
                    this.pageId + 'chart-bot-right',
                    currentData.purposeMixChartRight
                );
            }

            this.noDataDonutChart = currentData.noDataType;
            this.hasData = currentData.hasData;
        }
    }
}
